<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">到款查询</li>
      <text
        v-if="state.selectList?.filter((w) => w != -1)?.length > 0"
        style="margin-right: 10px; color: #1e90ff; line-height: 20px"
      >
        已选
        <strong style="color: #f00">{{
          state.selectIds?.filter((w) => w != -1)?.length
        }}</strong>
        条到款记录
      </text>
      <el-button
        type="warning"
        :icon="Select"
        link
        @click="onPiLiangRenLing"
        :disabled="!state.selectIds || state.selectIds?.length <= 0"
        v-if="$judge_auth('108')"
        >批量认领
      </el-button>
      <el-button
        type="warning"
        :icon="Connection"
        link
        @click="onHeBing"
        :disabled="!state.selectIds || state.selectIds?.length <= 0"
        v-if="$judge_auth('723')"
        >到款合并
      </el-button>
      <el-button
        type="warning"
        :icon="Document"
        link
        @click="state.showMergeList = true"
        v-if="$judge_auth('724')"
        >合并记录
      </el-button>
      <el-button
        type="primary"
        :icon="Upload"
        link
        @click="onExport"
        v-if="$judge_auth('834')"
        size="large"
        >导出
      </el-button>
    </ul>
    <ul class="c-list-search">
      <el-config-provider
        :value-on-clear="null"
        :empty-values="[undefined, null]"
      >
        <el-space wrap style="flex: 1">
          <el-input
            v-model="state.params.keywords"
            style="width: 200px"
            placeholder="付款账户、付款账号"
            clearable
            @clear="
              delete state.params.keywords;
              onLoad();
            "
            @paste.enter="$onKeywordsPaste($event, state.params)"
          ></el-input>
          <el-select
            v-model="state.bank_account_ids"
            style="width: 450px"
            placeholder="到账银行账户"
            multiple
            collapse-tags
            collapse-tags-tooltip
          >
            <el-option
              v-for="item in state.bankaccount_data"
              :key="item"
              :label="`${item.name}(${item.account})`"
              :value="item.id"
            />
          </el-select>
          <el-select
            v-model="state.params.customer_id"
            placeholder="认领客户"
            style="width: 300px"
          >
            <el-option
              v-for="item in state.customer_data"
              :key="item"
              :value="item.id"
              :label="item.name"
            ></el-option>
            <template #footer>
              <el-button size="small" @click="onLoadCustomer()">
                刷新
              </el-button>
            </template>
          </el-select>
          <el-select
            v-model="state.params.is_have_customer"
            style="width: 140px"
            placeholder="是否匹配客户"
          >
            <el-option label="未匹配客户" :value="0"></el-option>
            <el-option label="已匹配客户" :value="1"></el-option>
          </el-select>
          <el-select
            v-model="state.params.collected_status"
            style="width: 120px"
            placeholder="认领状态"
          >
            <el-option label="待认领" :value="0"></el-option>
            <el-option label="认领中" :value="1"></el-option>
            <el-option label="已认领" :value="2"></el-option>
          </el-select>
          <el-select
            v-model="state.params.freeze_status"
            style="width: 120px"
            placeholder="是否冻结"
          >
            <el-option label="未冻结" :value="0"></el-option>
            <el-option label="已冻结" :value="1"></el-option>
          </el-select>
          <el-select
            v-model="state.params.merge_status"
            style="width: 120px"
            placeholder="是否合并"
          >
            <el-option label="未申请" :value="0"></el-option>
            <el-option label="申请中" :value="1"></el-option>
            <el-option label="已合并" :value="2"></el-option>
          </el-select>
          <el-date-picker
            v-model="state.dates"
            type="daterange"
            range-separator="至"
            start-placeholder="到账日期"
            end-placeholder="到账日期"
            value-format="YYYY-MM-DD"
            @change="
              (value) => {
                if (value)
                  state.params.received_date = value[0] + ' - ' + value[1];
              }
            "
            style="width: 260px"
            @clear="
              delete state.dates;
              delete state.params.received_date;
            "
          />
          <el-date-picker
            v-model="state.create_times"
            type="datetimerange"
            range-separator="至"
            start-placeholder="创建日期"
            end-placeholder="创建日期"
            value-format="YYYY-MM-DD"
            @change="
              (value) => {
                if (value)
                  state.params.create_time = value[0] + ' - ' + value[1];
              }
            "
            style="width: 380px"
            @clear="
              delete state.create_times;
              delete state.params.create_time;
            "
          />
          <el-checkbox
            v-model="state.params.is_more"
            :true-value="1"
            :false-value="0"
            label="显示更多"
            :key="state.key"
            size="large"
            title="勾选显示未匹配客户的到款记录"
            @change="onLoad"
          />
          <el-dropdown split-button @click="onLoad" type="primary">
            查询
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                  重置
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-space>
      </el-config-provider>
    </ul>
    <ul class="c-list-table">
      <el-checkbox-group
        v-model="state.selectIds"
        style="flex: 1; display: flex; flex-direction: column; overflow: hidden"
      >
        <el-table
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          @sort-change="onSortChange"
        >
          <el-table-column width="55" fixed>
            <template #header>
              <el-checkbox :value="-1" @change="onSelectAll" />
            </template>
            <template #default="{ row }">
              <el-checkbox
                :value="row.id"
                @change="onSelect($event, row)"
                :disabled="row.collected_status == 2 || row.merge_status != 0"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="到款时间"
            prop="received_time"
            sortable="received_time"
            width="120"
            :formatter="$tab_TextFormat"
            fixed
          />
          <el-table-column
            label="付款人"
            prop="payment_name"
            :formatter="$tab_TextFormat"
            :min-width="160"
          />
          <el-table-column
            label="金额"
            prop="received_amount"
            align="right"
            :formatter="$tab_PriceFormat"
            min-width="140"
          />
          <el-table-column
            label="实际到账金额/手续费"
            align="right"
            :formatter="
              (row) =>
                $tab_GroupFormat(
                  $priceFormat(row.real_received_amount),
                  $priceFormat(row.service_fee),
                )
            "
            min-width="160"
          />
          <el-table-column
            label="已认领/未认领金额"
            min-width="160"
            align="right"
          >
            <template #default="{ row }">
              <div style="display: flex; justify-content: flex-end">
                <c_tabgroup
                  :value1="$priceFormat(row.collected_amount)"
                  style="
                    align-items: flex-end;
                    display: flex;
                    flex-direction: column;
                  "
                >
                  <template #bottom>
                    <c_money
                      style="font-weight: 600"
                      :value="row.uncollected_amount"
                    />
                  </template>
                </c_tabgroup>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态/ID" sortable="id" width="120">
            <template #default="{ row }">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  width: fit-content;
                "
              >
                <c_tabgroup :value2="row.id">
                  <template #top>
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        column-gap: 5px;
                      "
                    >
                      <el-tag
                        type="warning"
                        size="small"
                        title="合并申请中"
                        style="cursor: pointer"
                        v-if="row.merge_status == 1"
                        >合
                      </el-tag>
                      <el-tag
                        type="success"
                        size="small"
                        title="已合并"
                        style="cursor: pointer"
                        v-else-if="row.merge_status == 2"
                        >合
                      </el-tag>
                      <el-tag
                        type="primary"
                        size="small"
                        title="该到款记录为合并后的到款记录"
                        style="cursor: pointer"
                        v-if="row.is_merge"
                        >合
                      </el-tag>
                      <c_status
                        arr-name="bankReceived_collected_status"
                        :value="row.collected_status"
                      />
                    </div>
                  </template>
                </c_tabgroup>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="匹配客户"
            prop="customer_name"
            width="200"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="到账银行"
            :formatter="
              (row) =>
                $tab_GroupFormat(
                  row.bank_account?.account,
                  row.bank_account?.opening_bank || '',
                )
            "
            min-width="220"
          />
          <el-table-column
            label="付款银行"
            :formatter="
              (row) =>
                $tab_GroupFormat(row.payment_account, row.payment_bank || '')
            "
            min-width="220"
          />
          <el-table-column label="摘要信息/认领明细" min-width="400">
            <template #default="{ row }">
              <div>
                <ul>
                  {{
                    row.customer_name || "-"
                  }}
                </ul>
                <ul
                  v-if="row.collected_amount_detail?.collected"
                  style="
                    color: #a2a2a2;
                    font-size: var(--tab-group-second-font-size);
                  "
                  v-html="
                    Object.keys(row.collected_amount_detail?.collected)
                      .map(
                        (key) =>
                          `${key}: <text style='color:#ffa500;margin-right:5px'>${$priceFormat(
                            row.collected_amount_detail?.collected[key],
                          )}</text>`,
                      )
                      .join(' ')
                  "
                ></ul>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
            className="tabBtn"
          >
            <template #default="{ row }">
              <el-button
                type="primary"
                link
                icon="Select"
                @click="
                  $store.commit('openMenu', {
                    path: 'BankCollectedDetail',
                    title: '银行到账认领',
                    refresh: true,
                    data: {
                      id: row.id,
                    },
                  })
                "
                :title="
                  row.merge_status != 0
                    ? '该到款记录已申请合并，禁止单独认领'
                    : ''
                "
                :disabled="row.merge_status != 0"
                v-if="row.collected_status != 2 && $judge_auth('108')"
              >
                认领
              </el-button>
              <el-button
                type="primary"
                link
                icon="Search"
                @click="
                  $store.commit('openMenu', {
                    path: 'BankCollectedDetail',
                    title: '银行到账详情',
                    refresh: true,
                    data: {
                      id: row.id,
                    },
                  })
                "
                v-else
              >
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-checkbox-group>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showInfo"
        :title="(state.selectId ? '修改' : '添加') + '到账公示'"
        @close="state.showInfo = false"
      >
        <c_BankReceivedInfo
          @close="
            state.showInfo = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_BankReceivedInfo>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAdd"
        title="批量认领"
        @close="state.showAdd = false"
      >
        <c_BankCollectedAdd
          @close="
            state.showAdd = false;
            onLoad();
          "
          :data="state.selectList"
          @confirm="onAddConfirm"
        ></c_BankCollectedAdd>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showMerge"
        title="到款合并"
        @close="state.showMerge = false"
      >
        <c_BankCollectedMerge
          @close="state.showMerge = false"
          :data="state.selectList"
          @confirm="
            onLoad();
            state.showMerge = false;
            state.selectIds = [];
          "
        ></c_BankCollectedMerge>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showMergeList"
        title="合并记录"
        @close="state.showMergeList = false"
      >
        <c_BankCollectedMergeList
          @close="state.showMergeList = false"
        ></c_BankCollectedMergeList>
      </c_popup>
    </transition>
    <el-dialog
      v-model="state.showCustomer"
      title="关联客户"
      width="500px"
      align-center
    >
      <ul>
        请选择要关联的客户
      </ul>
      <el-select
        v-model="state.select_customer_id"
        size="large"
        style="margin-top: 5px"
      >
        <el-option
          v-for="item in state.customer_data"
          :key="item"
          :value="item.id"
          :label="item.name"
        ></el-option>
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <ul style="text-align: right; margin-top: 40px">
        <el-button
          type="primary"
          @click="
            state.showAdd = true;
            state.showCustomer = false;
          "
          size="large"
          style="width: 100%"
        >
          提交
        </el-button>
      </ul>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  bankcollected_list,
  bankcollected_exportReceived,
} from "@/http/bankcollected";
import { data_bankaccount_select, data_customer_select } from "@/http/data";
import { ElMessage } from "element-plus";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  setup() {
    const state = reactive({
      ...new InitFormData(),
      selectIds: [],
    });
    onMounted(() => {
      onLoadBankAcount();
      onLoad();
      onLoadCustomer();
    });

    const onLoadBankAcount = () => {
      data_bankaccount_select().then((res) => {
        if (res.status == 200) {
          state.bankaccount_data = res.data.data?.list;
        }
      });
    };

    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) {
          state.customer_data = res.data.data?.list;
        }
      });
    };

    const onLoad = () => {
      delete state.tableData;
      if (state.bank_account_ids?.length > 0)
        state.params.bank_account_id = state.bank_account_ids.join(",");

      bankcollected_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;

          state.selectIds = state.selectIds.filter((w) => w != -1);
        }
      });
    };

    const onDateChange = (value) => {
      if (value) state.params.received_date = value[0] + " - " + value[1];
    };

    const onSelectAll = (checked) => {
      if (checked) {
        state.selectIds = [
          ...state.selectIds,
          ...state.tableData
            .filter((w) => w.collected_status != 2 && w.merge_status == 0)
            .map((m) => m.id),
        ];
      } else {
        const tableIds = state.tableData.map((m) => m.id);
        state.selectIds = state.selectIds.filter((w) => !tableIds.includes(w));
      }
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.bank_account_ids;
      Object.assign(state, new InitFormData());
      state.key = Math.random();
      onLoad();
    };

    const onPiLiangRenLing = () => {
      if (state.selectIds?.length > 0) {
        bankcollected_list({
          limit: 0,
          id: state.selectIds.filter((w) => w != -1).join(","),
          is_more: true,
        }).then((res) => {
          if (res.status == 200) {
            const { list } = res.data.data;

            let error = false;

            let customer_id;

            list.forEach((e) => {
              if (!error) {
                if (e.collected_status == 2) {
                  ElMessage({
                    type: "warning",
                    dangerouslyUseHTMLString: true,
                    message: `到款记录(ID:${e.id})已全部认领完成，禁止重复操作！`,
                  });
                  error = true;
                  return false;
                }

                if (e.merge_status != 0) {
                  ElMessage({
                    type: "warning",
                    dangerouslyUseHTMLString: true,
                    message: `到款记录(ID:${e.id})已合并，禁止单独处理！`,
                  });
                  error = true;
                  return false;
                }

                if (!customer_id) customer_id = e.customer_id;
                else {
                  if (e.customer_id && e.customer_id != customer_id) {
                    ElMessage({
                      type: "warning",
                      dangerouslyUseHTMLString: true,
                      message: `到款记录(ID:${e.id})已绑定客户，且与当前已选到款记录的客户不一致，无法批量操作！`,
                    });
                    error = true;
                    return false;
                  }
                }
              }
            });

            if (!error) {
              state.selectList = list;
              state.showAdd = true;
            }
          }
        });
      } else {
        ElMessage({
          type: "warning",
          dangerouslyUseHTMLString: true,
          message: `请选择要操作的到款记录！`,
        });
      }
    };

    const onHeBing = () => {
      if (state.selectIds?.length > 0) {
        bankcollected_list({
          limit: 0,
          id: state.selectIds.filter((w) => w != -1).join(","),
          is_more: true,
        }).then((res) => {
          if (res.status == 200) {
            const { list } = res.data.data;

            let error = false;

            let customer_id;

            list.forEach((e) => {
              if (!error) {
                if (e.collected_status != 0) {
                  ElMessage({
                    type: "warning",
                    dangerouslyUseHTMLString: true,
                    message: `到款记录(ID:${e.id})状态不正确！到款合并只允许勾选未认领的到款记录！`,
                  });
                  error = true;
                  return false;
                }

                if (e.is_merge) {
                  ElMessage({
                    type: "warning",
                    dangerouslyUseHTMLString: true,
                    message: `到款记录(ID:${e.id})为合并后系统生成的到款记录，无法再次合并！`,
                  });
                  error = true;
                  return false;
                }

                if (e.merge_status != 0) {
                  ElMessage({
                    type: "warning",
                    dangerouslyUseHTMLString: true,
                    message: `到款记录(ID:${e.id})已合并，禁止单独处理！`,
                  });
                  error = true;
                  return false;
                }

                if (!customer_id) customer_id = e.customer_id;
                else {
                  if (e.customer_id && e.customer_id != customer_id) {
                    ElMessage({
                      type: "warning",
                      dangerouslyUseHTMLString: true,
                      message: `到款记录(ID:${e.id})已绑定客户，且与当前已选到款记录的客户不一致，无法批量操作！`,
                    });
                    error = true;
                    return false;
                  }
                }
              }
            });

            if (!error) {
              state.selectList = list;
              state.showMerge = true;
            }
          }
        });
      } else {
        ElMessage({
          type: "warning",
          dangerouslyUseHTMLString: true,
          message: `请选择要操作的到款记录！`,
        });
      }
    };

    const onAddConfirm = () => {
      state.selectIds = [];
      state.showAdd = false;
      onLoad();
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      bankcollected_exportReceived(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1],
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDateChange,
      onPiLiangRenLing,
      onLoadCustomer,
      onAddConfirm,
      onHeBing,
      onSelectAll,
      onExport,
    };
  },
};
</script>
<style lang="less">
.bank-received-index-tab-pop {
  .el-descriptions__header {
    margin-bottom: 0 !important;
  }
}
</style>
